import { useContext, useState } from "react";
import RecipeContext from "../components/store/recipe-context";
import TextareaAutosize from "react-textarea-autosize";
import css from "./Import.module.css";
import ImportRecipeContext from "./store/import-recipe-context";
import Section from "./section";
import Button from "./Button";
import TabContext from "./store/tab-context";
import ImportRules from "./ImportRules";
import ConvertIngredients from "./ConvertIngredients/ConvertIngredients";

function Import(props) {
  const importRecipeContext = useContext(ImportRecipeContext);
  const tabContext = useContext(TabContext);

  function onClick() {
    importRecipeContext.importRecipe();
    tabContext.updateValue(tabContext.values.export);
  }

  return (
    <div>
      <ImportRules />
      <Section sectionStyle="alignCenter" largeBottomMargin={true}>
        <div className={css.textareaAutosizeContainer}>
          <TextareaAutosize
            id="importTextarea"
            className={css.textareaAutosize}
            placeholder={"Enter Recipe"}
            minRows={40}
            defaultValue={importRecipeContext.text}
            onChange={(event) =>
              importRecipeContext.setText(event.target.value)
            }
          />
        </div>

        <div className={css.convertAndImportContainer}>
          <ConvertIngredients
            setToggleBool={importRecipeContext.setToggelBool}
            toggleBool={importRecipeContext.toggleBool}
            setSelectedMeasurement={importRecipeContext.setSelectedMeasurement}
          />
          <Button onClick={onClick}>Import Recipe</Button>
        </div>
      </Section>
    </div>
  );
}

export default Import;
